"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndermoonDrugLordsNetwork = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var UndermoonDrugLordsNetwork = (function (_super) {
    __extends(UndermoonDrugLordsNetwork, _super);
    function UndermoonDrugLordsNetwork() {
        return _super.call(this, {
            name: CardName_1.CardName.UNDERMOON_DRUG_LORDS_NETWORK,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON],
            cost: 2,
            metadata: {
                description: 'Increase your M€ production 1 step per 2 steps of Colony Rate.',
                cardNumber: 'M81',
                victoryPoints: -1,
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1);
                    }).slash().moonColonyRate({ amount: 2 });
                }),
            },
        }) || this;
    }
    ;
    UndermoonDrugLordsNetwork.prototype.play = function (player) {
        var gain = Math.floor(MoonExpansion_1.MoonExpansion.moonData(player.game).colonyRate / 2);
        player.addProduction(Resources_1.Resources.MEGACREDITS, gain, { log: true });
        return undefined;
    };
    UndermoonDrugLordsNetwork.prototype.getVictoryPoints = function () {
        return -1;
    };
    return UndermoonDrugLordsNetwork;
}(Card_1.Card));
exports.UndermoonDrugLordsNetwork = UndermoonDrugLordsNetwork;
